import Blue from '~/core';
new Blue({
	name: 'mobile tags',
	selector: '.tags',
	setup(tags) {
		const triggers = [...tags.querySelectorAll('.tags__close, .tags__toggle')];
    	const titles = tags.querySelectorAll('.tags__title');
		const optionInners = tags.querySelectorAll('.tags__options-inner');
		const isOfficerLookup = tags.classList.contains('tags--officer-lookup');
		if(!isOfficerLookup) {
			let relations = [];
			optionInners.forEach(inner => {
				if (inner.scrollHeight > 240) {
					inner.classList.add("tags__options-inner--scrollable")
				}
			});		
			titles.forEach(title => {
				let trigger = title
				let content = title.nextElementSibling
				let container = title.parentElement
				let config = {
					container,
					trigger,
					content,
					relations,
					props: ["height", "visibility", "box-shadow"],
				}
				relations.push(new this.$toggle(config))
			})
			this.$addEvents(document, 'click', (e) => {
				relations.forEach(toggle => {
					toggle.close()
				})
			});
			this.$addEvents(triggers, 'click.prevent enter.prevent', () => {
				relations.forEach(toggle => {
					toggle.close()
				})
			});
		}
	},
});